export const getStripeClientSecret = (state) => state.payment.stripe.clientSecret;
